import { queryOptions, useQuery } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { fetchTargetingVocabulary } from '../../api/targetingApi';

import { targetingKeys } from './keys';

// The response carries the feature switches next to the enums, so it must not be cached for the
// whole session: a switched flag would otherwise only show after a reload.
export const targetingVocabularyOptions = () =>
	queryOptions({
		queryKey: targetingKeys.vocabulary,
		queryFn: fetchTargetingVocabulary,
		staleTime: STALE_TIMES.STANDARD,
	});

export const useTargetingVocabulary = () => useQuery(targetingVocabularyOptions());
